import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import MainStore from '../../../../MainStore';
import { fetchWithAuth } from '../../../Auth/GlobalFetchWithAuth';
import WorkStore from '../WorkStore';

export default class ChildWorks extends Component {

    constructor(props) {
        super(props);

        this.state = {
            works: [],
            columns: [
                { title: 'Номер', field: 'number' },
                { title: 'Заголовок', field: 'caption' },
                { title: 'Состояние', field: 'status' },
            ]
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.loadWorks = this.loadWorks.bind(this);
        this.openWorkDialog = this.openWorkDialog.bind(this);
    }

    componentDidMount() {
        this.loadWorks();
    }

    componentDidUpdate(props) {
        if (this.props.parentId !== props.parentId) this.loadWorks();
    }

    loadWorks() {
        if (!this.props.parentId) {
            this.setState({ works: [] });
            return;
        }
        this.setState({ works: [] });
        var scope = this;
        fetchWithAuth('api/Work/GetWorkByParent?parentId=' + this.props.parentId,
            null,
            "application/json",
            res => {
                scope.setState({ works: res });
            },
            "GET"
        );
    }

    handleClear() {
        this.setState({ name: '', id: '', isOpen: false });
        this.props.handleSelect({ name: '', id: '' });
    }

    handleOpen(e) {
        this.setState({ isOpen: true });
        this.loadWorks('');
    }

    handleBlur(e) {
        this.setState({ isOpen: false });
    }

    openWorkDialog() {
        MainStore.setMaskVisible();
        var scope = this;
        fetch('api/Work/GetById?id=' + this.state.id, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {

            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    MainStore.openWorkDialog(result, work => {
                        let works = this.state.works.slice(0);
                        let index = works.findIndex(w => w.id === work.id);
                        works.splice(index, 1, work);
                        this.setState({ works: works });
                    });
                }).catch((err) => console.log(err));
            }
        });
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    cloneWork() {
        return {
            caption: "",
            sessionId: this.uuidv4(),
            description: '',
            sp: -1,
            parentId: this.props.parentId,
            parentNumber: this.props.parentNumber,
            account: this.props.work.account,
            accountId: this.props.work.accountId,
            accountColor: this.props.work.accountColor,
            projectId: this.props.work.projectId,
            projectName: this.props.work.projectName,
            assignee: '',
            assigneeId: null,
            approvedHour: 0,
            planHour: 0,
            factTotal: 0
        };
    }

    openWorkDialog(data) {
        MainStore.setMaskVisible();
        var scope = this;
        fetchWithAuth(
            'api/Work/GetByWorkId?id=' + data.id,
            null,
            'application/json',
            (result) => {
                MainStore.setMaskUnvisible();
                WorkStore.openWorkDialog(result, (project) => {
                    scope.setState({ 'name': project.name });
                });
            },
            'GET'
        );
    }

    render() {
        return (
            <div className="clearfix child-works-table">
                <MaterialTable
                    title="Дочерние задачи"
                    columns={this.state.columns}
                    data={this.state.works}
                    editable={{
                        onRowDelete: oldData =>
                            new Promise(resolve => {
                                //this.deleteEnvironment(oldData, resolve);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'add',
                            tooltip: 'Добавить задачу',
                            isFreeAction: true,
                            onClick: (event) => WorkStore.openWorkDialog(this.cloneWork(), work => {
                                let works = this.state.works.slice(0);
                                works.push(work);
                                this.setState({ works: works });
                            })
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => this.openWorkDialog(rowData)
                        }
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        grouping: false
                    }}
                />
            </div>
        );
    }
}
